import { render } from "./RenameKeyButton.vue?vue&type=template&id=0ae7db99&scoped=true&lang=pug"
import script from "./RenameKeyButton.vue?vue&type=script&lang=js"
export * from "./RenameKeyButton.vue?vue&type=script&lang=js"

import "./RenameKeyButton.vue?vue&type=style&index=0&id=0ae7db99&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae7db99"]])

export default __exports__